__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/54eb02d59cafaef715af76df34156f8b35da118f/_next/";